import React from 'react';
import { Form, Button,Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ContactForm from '../pages/contact.js';
import {
    Col,
} from "reactstrap";

import TopBar from '../publicWebsite/topbar.js';

const PublicContactForm = () => {

    return (

        <React.Fragment>
            <TopBar />
            <div className="'page-content " >
                <Row className="justify-content-center  ">
                    <Col xl={9}>
                        <ContactForm />
                    </Col>
                </Row>
            </div>

        </React.Fragment>
    );

}

export default PublicContactForm;